import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../service/proveedores/proveedores.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../../success-dialog/success-dialog.component';
import { SpinnerService } from '../../../service/spinner-service/spinner.service';
import { lastValueFrom } from 'rxjs';


@Component({
  selector: 'app-nueva-compra-dialog',
  templateUrl: './nueva-compra-dialog.component.html',
  styleUrl: './nueva-compra-dialog.component.scss'
})
export class NuevaCompraDialogComponent {

  headerTitle
  editMode
  loadingView = true
  solicitudForm: FormGroup
  conceptosForms: FormGroup

  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private spinnerService: SpinnerService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private provedorService: ProveedoresService,
    public dialogRef: MatDialogRef<NuevaCompraDialogComponent>) {
      this.editMode = data.editMode
      this.headerTitle = this.editMode ? 'Editar Solicitud de Compra' : 'Nueva Solicitud de Compra'
      this.solicitudForm = this.fb.group({
        solicitante: ['', [Validators.required]],
        dptoSolicitante: ['', [Validators.required]],
        fechaSolicitud: [{value: new Date(), disabled: true}],
        fechaRequerida: ['', [Validators.required]],
        justificante: ['', [Validators.required]]
      })

      this.conceptosForms = this.fb.group({
        forms: this.fb.array([]) 
      })


      this.loadingView = false
  }

  ngOnInit() {

  }

  // getter para acceder fácil al FormArray
  get forms(): FormArray {
    return this.conceptosForms.get('forms') as FormArray;
  }

  // crear un grupo de 3 inputs
  createFormGroup(): FormGroup {
    return this.fb.group({
      concepto: ['', [Validators.required]],
      cantidad: ['', [Validators.required]],
      especificaciones: ['', [Validators.required]],
      pu: ['', [Validators.required]],
      total: ['', [Validators.required]],
      observaciones: ['', [Validators.required]]
    });
  }

  // agregar un nuevo form
  addForm() {
    this.forms.push(this.createFormGroup());
  }

  // eliminar un form por índice
  removeForm(index: number) {
    this.forms.removeAt(index);
  }

  // enviar datos
  onSubmit() {
    console.log(this.conceptosForms.value);
    // value será algo como:
    // { forms: [ {campo1: '...', campo2: '...', campo3: '...'}, {...}, ... ] }
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }
} 
